module.exports = __webpack_public_path__ + "img/head.a650bc43.png";